import React from "react";
import { Box, Typography } from "@mui/material";
import dayjs from "dayjs";
import DisplayAttachments from "./displayAttachments";
import { useSelector } from "react-redux";
import EventMessage from "./EventMessage.tsx";
import TicketCreated from "./TicketCreated.tsx";
import DisplayMetraIds from "../chatInputSection/displayMetraIds.tsx";
import Ifu from "./IFU.tsx";

interface Attachment {
    thumbnails: any;
    id: number;
    fileName: string;
    contentUrl: string;
}

interface Comment {
    id: number;
    createdAt: string;
    body: string;
    attachments: Attachment[];
    autherId: number;
    public: boolean;
    searchIFU?: boolean;
}

interface User {
    id: number;
    name: string;
    email: string | null;
    organizationId: number | null;
}

interface ChatProps {
    comments: Comment[];
    users: User[];
    scrollRef: React.MutableRefObject<HTMLDivElement | null>;
}

const ChatMessages: React.FC<ChatProps> = ({ comments, users, scrollRef }) => {
    const { user } = useSelector((state: any) => state.user);

    const getUserName = (authorId: number) => {
        const userName =
            users?.find((user) => user?.id === authorId)?.name ?? 'O X';
        const word = userName.split(" ");
        return word.map((word) => word?.charAt(0).toUpperCase());
    };

    return (
        <>
            {
                comments?.map((item) => {
                    const comment = {...item}
                    const id = comment.id ? comment.id.toString() : comment.createdAt;
                    if (comment.body.startsWith('base64;') && !comment.attachments?.length) {
                        if (atob(comment.body.slice(7)) == 'ticket_created') {
                            return <TicketCreated key={id}/>
                        }
                        return <EventMessage item={comment} key={id}/>
                    }
                    if (comment.body === "Please enter the Metra ID") {
                        return <DisplayMetraIds key={id}/>
                    }
                    if (comment.searchIFU) {
                        return <Ifu key={id}/>
                    }
                    if (comment.body.startsWith('base64;')) {
                        comment.body = comment.body.slice(7)
                    }
                    return (
                        <>
                            {comment.public &&
                                <Box
                                    key={id}
                                    ref={scrollRef}
                                    sx={{
                                        display: "flex",
                                        flexDirection:
                                            comment.autherId === user.zendeskUserId ? "row-reverse" : "row",
                                        marginTop: "2rem",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            alignItems: "flex-end",
                                            display: "flex",
                                            flexDirection: "column",
                                            width: "auto",
                                            maxWidth: "80%",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection:
                                                    comment.autherId === user.zendeskUserId ? "row-reverse" : "row",
                                            }}
                                        >
                                            {comment.autherId !== user.zendeskUserId && (
                                                <Box
                                                    sx={{
                                                        borderRadius: "50%",
                                                        bgcolor: "#fff",
                                                        width: "35px",
                                                        height: "35px",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        mr: 1,
                                                    }}
                                                >
                                                    <Typography
                                                        className="!text-[10px] md:!text-[14px]"
                                                        sx={{fontSize: "0.8rem"}}
                                                    >
                                                        {getUserName(comment.autherId)}
                                                    </Typography>
                                                </Box>
                                            )}
                                            <Box
                                                sx={{
                                                    bgcolor: "#fff",
                                                    p: comment.attachments.length === 0 ? 2 : 1,
                                                    borderRadius: 1,
                                                }}
                                            >
                                                <DisplayAttachments
                                                    comment={comment}
                                                />
                                                <Typography >{comment.body}</Typography>
                                            </Box>
                                        </Box>
                                        <Box>
                                            <Typography variant="caption" color="textSecondary">
                                                {dayjs(comment.createdAt).format("DD-MMM-YYYY HH:mm")}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            }
                        </>
                    )
                })}
        </>
    );
};
export default ChatMessages;
